module.exports = __webpack_public_path__ + "static/img/IMG_20240803_092516.5316a037.jpg";